import React from 'react';

import { faStar } from '@fortawesome/free-regular-svg-icons';
import { faStar as solidFaStar } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as ExternalLinkIcon } from '../../../../assets/images/external_link_icon.svg';
import { t } from '../../../../providers';

const useStyles = makeStyles(() => ({
    addFavoriteBtn: {
        color: '#000',
        marginLeft: '20px',
        marginRight: '6px',
        fontSize: '0.75rem',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '@media (max-width:600px)': {
            marginLeft: '5px',
            marginRight: '0px',
        },
    },
    favoriteBtn: {
        color: '#443205',
    },
    linkBtn: {
        fontSize: '0.875rem',
        color: '#086B9C',
        textDecoration: 'underline',
        letterSpacing: '0.25px',
        lineHeight: '142%',
        fontFamily: 'Open Sans',
        borderRadius: 'unset',
        '&:focus-visible': {
            backgroundColor: 'rgba(209, 224, 194, 0.2)',
            outline: 'none',
            border: '2px dashed #4F7E1D',
            borderRadius: '3px',
        },
        '@media (max-width:600px)': {
            fontSize: '0.8125rem',
        },
        '& .MuiIconButton-root': {
            borderRadius: 'unset',
        },
    },
    linkBtnIcon: {
        paddingLeft: '10px',
    },
    focusedElement: {
        backgroundColor: 'rgba(209, 224, 194, 0.2)',
        outline: 'none',
        border: '2px dashed #4F7E1D',
        borderRadius: '3px',
    },
}));

const CatalogueListItem = ({ item = {}, navigateTo, toggleFavorites, handleEnterKey }) => {
    const classes = useStyles();
    const starIcon = item.favorite ? solidFaStar : faStar;
    const starStyle = item.favorite ? classes.favoriteBtn : '';

    return (
        <div>
            <IconButton
                id={`starBtn-${item.title}`}
                aria-pressed={item.favorite ? true : false}
                disableFocusRipple
                aria-label={`${t('mark.as.favorite')} ${t(item.title)}`}
                size="small"
                className={classes.addFavoriteBtn}
                onClick={() => toggleFavorites(item)}
                onKeyDown={(event) => {
                    if (event.key === 'Enter') {
                        handleEnterKey(item);
                    }
                }}>
                <FontAwesomeIcon role="presentation" icon={starIcon} className={starStyle} aria-hidden="true" focusable="false" />
            </IconButton>
            <IconButton
                disableFocusRipple
                role="link"
                aria-label={`${t(item.title)}. ${t('open.new.tab')}`}
                size="small"
                className={classes.linkBtn}
                onClick={(e) => navigateTo(e, item.path)}>
                {t(item.title)}
                <ExternalLinkIcon className={classes.linkBtnIcon} aria-hidden="true" focusable="false" />
            </IconButton>
        </div>
    );
};

export default CatalogueListItem;
